import { render, staticRenderFns } from "./vessels-view.vue?vue&type=template&id=daf4a01a&scoped=true"
import script from "./vessels-view.vue?vue&type=script&lang=js"
export * from "./vessels-view.vue?vue&type=script&lang=js"
import style0 from "./vessels-view.vue?vue&type=style&index=0&id=daf4a01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf4a01a",
  null
  
)

export default component.exports